export const siteSettings = {
  name: "Logistics Crypt City",
  link: "https://logisticscryptcity.live",
  email: "support@logisticscryptcity.live",
  appLink: "https://app.logisticscryptcity.live",
};
